import util from '../util';
import store from '../store';

class SequencePlayer {
  constructor(config) {
    this.$el = $(config.el);

    this.$store = {
      path: '',
      prefix: 'sequence_',
      loop: false,
      loopSequence: {
        frame: -1,
        fps: 60
      },
      autoPlay: false,
      delay: 0,
      frame: 0,
      preload: false,
      animationFrame: false,
      animationFrameLoop: false,
      isPlay: false,
      nowFrame: 0,
      loadCount: 0,
      screenWidth: 0,
      screenHeight: 0,
      sequence: [],
      canPlay: false,
      playQ: false,
      uniqueId: '',
      hover: false,
      isHover: false,
      ...config
    };

    if (!config.fps) {
      this.$store.fps = 60;
    }

    this.$canvas = $(`<canvas></canvas>`);
    this.$el.append(this.$canvas);
    this.$el.addClass('promokit-sequence');
    this.$canvasContext = this.$canvas[0].getContext('2d');

    for (let i = 0; i < this.$store.frame; i++) {
      this.loadData(`${this.$store.path}/${this.$store.prefix}${i}.png`, i);
    }

    for (let i = 0; i < this.$store.loopSequence.frame; i++) {
      this.loadData(`${this.$store.loopSequence.path}/${this.$store.loopSequence.prefix}${i}.png`, this.$store.frame + i);
    }

    if (this.$store.preload) {
      store('preloadLength.sequence', Number(store('preloadLength.sequence')) + Number(this.$store.frame) + Number(this.$store.loopSequence.frame));
    }

    this.$store.uniqueId = `sequence.${util.uniqueId()}`;

    this.$el.attr('data-store', this.$store.uniqueId);

    store(this.$store.uniqueId, this);

    if (this.$store.hover) {
      this.handleHoverPlay();
    }
  }

  handleHoverPlay() {
    this.$el.addClass('promokit-sequence--cloak');

    this.$el.on('mouseenter', () => {
      this.play();
      this.$store.isHover = true;
      this.$el.removeClass('promokit-sequence--cloak');
    });

    this.$el.on('mouseleave', () => {
      this.$store.isHover = false;
      this.$el.addClass('promokit-sequence--cloak');
    });

    this.$el.on('transitionend', () => {
      !this.$store.isHover && this.pause();
    });
  }

  loadData(src, i) {
    const img = new Image();
    img.src = src;
    img.onload = () => this.loadComplete(img, i);
    img.onerror = () => this.loadFail();
  }

  loadFail() {
    if (this.$store.preload) {
      store('preloadLength.sequence', Number(store('preloadLength.sequence')) - 1);
    }
  }

  loadComplete(img, index) {
    this.$store.sequence[index] = img;

    if (this.$store.preload) {
      store('preloadLength.sequence', Number(store('preloadLength.sequence')) - 1);
    }

    this.$store.loadCount += 1;

    if (index === 0) {
      this.$store.screenWidth = this.$store.sequence[0].width;
      this.$store.screenHeight = this.$store.sequence[0].height;

      this.$canvas.attr({
        width: this.$store.screenWidth,
        height: this.$store.screenHeight
      });
    }

    if (this.$store.loadCount == (this.$store.frame + this.$store.loopSequence.frame)) {
      this.handleReady();
    }
  }

  handleReady() {
    this.$store.canPlay = true;

    this.$el.trigger('canplay');

    this.$store.autoplay && setTimeout(() => {
      this.play();
    }, this.$store.delay);
  }

  render(q) {
    this.$canvasContext.clearRect(0, 0, this.$store.screenWidth, this.$store.screenHeight);
    this.$canvasContext.drawImage(this.$store.sequence[q], 0, 0);
    this.$store.nowFrame = q + 1;
  }

  play(to) {
    if (this.$store.isPlay) return;

    if (this.$store.canPlay) {
      this._play(to);
    }
    else {
      if (this.$store.playQ) return;
      this.$store.playQ = true;

      this.$el.on('canplay.q', () => {
        if (this.$store.playQ) {
          this._play(to);
        }
      });
    }
  }

  _play(to) {
    this.$store.isPlay = true;

    to > -1 && this.seek(to);

    this.$el.trigger(`play`);

    if (this.$store.loopSequence.frame < 0) {
      this.$store.animationFrame = util.animationFrame(() => {
        if (this.$store.nowFrame >= this.$store.frame) {
          this.$store.isPlay = false;
          this.$store.animationFrame.stop();
          this.$el.trigger(`end`);
          if (this.$store.loop) {
            this.play(0);
          }
          return;
        }

        this.render(this.$store.nowFrame);
      }, this.$store.fps);
    }

    if (this.$store.loopSequence.frame > 0) {
      this.$store.animationFrameLoop = util.animationFrame(() => {

        if (this.$store.nowFrame >= (this.$store.frame + this.$store.loopSequence.frame)) {
          this.$store.animationFrameLoop.stop();
          this.$store.isPlay = false;
          this.$el.trigger(`end`);
          this.play(this.$store.frame);
          return;
        }

        this.render(this.$store.nowFrame);
      }, this.$store.loopSequence.fps);

      this.$store.animationFrame = util.animationFrame(() => {
        if (this.$store.nowFrame >= this.$store.frame) {
          this.$store.animationFrame.stop();
          this.$store.animationFrameLoop.start();
          return;
        }

        this.render(this.$store.nowFrame);
      }, this.$store.fps);
    }

    this.$store.animationFrame.start();
  }

  pause() {
    this.$store.playQ = false;
    this.$store.isPlay = false;
    this.$store.animationFrame && this.$store.animationFrame.stop();
    this.$store.animationFrameLoop && this.$store.animationFrameLoop.stop();
    this.$el.trigger(`pause`);
  }

  stop() {
    this.$store.playQ = false;
    this.$store.isPlay = false;

    this.$store.animationFrame && this.$store.animationFrame.stop();
    this.$store.animationFrameLoop && this.$store.animationFrameLoop.stop();

    this.render(0);
    this.$el.trigger(`stop`);
  }

  seek(to) {
    this.$store.nowFrame = to;
    this.render(this.$store.nowFrame);
    this.$el.trigger(`seek`);
  }

  on(event, func) {
    this.$el.on(event, func);
  }

  off(event) {
    this.$el.off(event);
  }

  get info() {
    return this.$store;
  }
}

export default SequencePlayer;
